import { SaveButton } from "../../../components/SaveButton";


export default {
    init(){
        this.initModal();
        this.getFormItems();
        this.modifierMenu();
        this.confirmDelete();
        this.openAttributeEditor();
        this.initOptionReorder();
    },

    /**
     * The row opens the set — the same behaviour as a Services row. The two sibling tables sit
     * under one tab strip; a row that does nothing on one of them and navigates on the other is a
     * bug, not a variation.
     */
    openAttributeEditor(){
        $('body').off('click', '.bb-attr-row')
            .on('click', '.bb-attr-row', function (e) {
                if ($(e.target).closest('button, a, input, label').length) return;
                // Archived questions are read-only until restored — there is no edit row to open.
                if ($(this).hasClass('is-archived')) return;
                $(this).find('.attributes-list__table-controls-row-item[data-action="edit"]').trigger('click');
            });
    },

    /**
     * Deleting an attribute set used to be a bare <a href> straight to the route: one click, no
     * question asked, and it happily removed a set that services were still using. Now it asks,
     * names the set, and goes over DELETE.
     */
    /**
     * Reordering the options inside a question.
     *
     * The old editor could do this and the rebuild lost it, which matters because this order IS the
     * order the customer reads on the booking form. Two ways, same as everywhere else in this area:
     * drag the handle, or click it for Move up / Move down when the list is longer than the screen.
     *
     * The starting row is pinned. It is the baseline the service's own price already covers, so it
     * has no handle and nothing can be dropped above it.
     *
     * Nothing is posted here — `modifiers[…]` is read back in DOM order and saveAttribute() writes
     * `array_values()`, so the order on screen is the order that saves. Per-service prices follow
     * their option across the move, because carryPricesAcrossEdit() matches on the option's title.
     */
    initOptionReorder() {
        const self = this;

        // Move up / Move down from the grip menu.
        $('body').off('click.attropt').on('click.attropt', '.attr-option-move', function () {
            if ($(this).is('[disabled]')) return;
            const row = $(this).closest('.attributes-edit-row');
            const dir = $(this).data('sort-direction');
            if (dir === 'up') {
                const prev = row.prev('.attributes-edit-row');
                if (prev.length && !prev.hasClass('is-first')) prev.before(row);
            } else {
                const next = row.next('.attributes-edit-row');
                if (next.length) next.after(row);
            }
            self.afterReorder();
        });

        // Drag. Delegated on body because the modal's rows are injected after this runs.
        let dragged = null;
        $('body').off('dragstart.attropt dragover.attropt drop.attropt dragend.attropt')
            .on('dragstart.attropt', '.attributes-edit-row .bb-grip__handle', function (e) {
                dragged = $(this).closest('.attributes-edit-row')[0];
                if (!dragged) return;
                dragged.classList.add('is-dragged');
                const dt = e.originalEvent.dataTransfer;
                dt.effectAllowed = 'move';
                dt.setData('text/plain', dragged.id || 'row');
            })
            .on('dragover.attropt', '.attributes-edit-row', function (e) {
                if (!dragged) return;
                const over = this;
                // The starting row keeps its place; you cannot drop onto or above it.
                if (over === dragged || over.classList.contains('is-first')) return;
                e.preventDefault();
                e.originalEvent.dataTransfer.dropEffect = 'move';
                const cell = over.querySelector('.bb-mod-row__cell');
                const box = (cell || over).getBoundingClientRect();
                const below = e.originalEvent.clientY > box.top + box.height / 2;
                over.parentNode.insertBefore(dragged, below ? over.nextSibling : over);
            })
            .on('drop.attropt', '.attributes-edit-row', function (e) { e.preventDefault(); })
            .on('dragend.attropt', '.attributes-edit-row .bb-grip__handle', function () {
                if (!dragged) return;
                dragged.classList.remove('is-dragged');
                dragged = null;
                self.afterReorder();
            });
    },

    /**
     * The preview under the rows lists the options in order and is redrawn on input, not on
     * reorder — so after a drag it kept showing the old order while the rows above it showed the
     * new one. Two answers on one screen is worse than either.
     */
    afterReorder() {
        this.renderPreview();
        $('#attributes-rows').trigger('change'); // wakes the Save-enable check
    },

    confirmDelete(){
        // Undo it. Restoring puts the question back on every service that had it, with each of
        // those services' own prices still on its own link.
        $('body').off('click', '.bb-attr-restore').on('click', '.bb-attr-restore', function () {
            const btn = $(this).attr('disabled', true);
            $.ajax({
                method: 'POST',
                url: '/services-management/attributes/restore-attribute/' + $(this).data('attribute-id'),
                data: { _token: $('meta[name="csrf-token"]').attr('content') },
                success: function () { window.location.reload(); },
                error: function () { btn.removeAttr('disabled'); },
            });
        });

        $('body').off('click', '.attributes-list__table-controls-row-item[data-action="delete"]')
            .on('click', '.attributes-list__table-controls-row-item[data-action="delete"]', function(e){
                e.preventDefault();
                let id = $(this).data('attribute-id');
                let title = $(this).data('attribute-title') || 'this attribute set';
                let modal = $('#attribute-delete-confirm');
                // The old wording was vague AND untrue: it said "every service using it" without
                // saying how many, and "this cannot be undone" when the delete is recoverable —
                // the row is kept, and so is each service's own pricing for it.
                let used = Number($(this).data('used-by') || 0);
                let where = used === 0
                    ? 'No service uses it yet.'
                    : 'It will disappear from ' + used + ' service' + (used === 1 ? '' : 's')
                      + ' straight away.';
                modal.find('.confirm-text').text(
                    'Delete “' + title + '”? ' + where
                    + ' Nothing is lost — it moves to Archived, keeps each service’s own prices, '
                    + 'and can be restored. Appointments already booked are not affected.'
                );
                modal.find('.confirm-delete-attribute').attr('data-id', id);
                modal.modal('show');
            });

        $('body').off('click', '.confirm-delete-attribute')
            .on('click', '.confirm-delete-attribute', function(){
                let id = $(this).attr('data-id');
                if (!id) return;
                let btn = $(this).attr('disabled', true);
                $.ajax({
                    type: 'POST',
                    url: '/services-management/attributes/delete-attribute/' + id,
                    data: {
                        _method: 'DELETE',
                        _token: $('meta[name="csrf-token"]').attr('content') || $('input[name="_token"]').first().val(),
                    },
                    success: function(){ location.reload(true); },
                    error: function(){
                        btn.removeAttr('disabled');
                        $('#attribute-delete-confirm').find('.confirm-text')
                            .text('That could not be deleted. Reload the page and try again.');
                    }
                });
            });
    },

    initModal() {
        let _this = this;
        $('.attributes-list__table-controls-button-add, .attributes-list__table-controls-row-item').click(function (e) {
            let action = $(this).data('action');
            if (action == 'delete'){
                // Handled by confirmDelete(); never fall through to the route.
                return true;
            }
            let attributeId = $(this).data('attribute-id');
            e.preventDefault();
            let ajaxData = {
                type: 'GET',
                url: '/services-management/attributes/get-form',
                success: function (response) {
                    $('#form-container').html(response);
                    $('#attributes-modal').modal('show');
                    _this.kindChange();
                    _this.picksChange();
                    _this.unitChange();
                    _this.directionChange();
                    _this.addModifier();
                    _this.sortModifier();
                    _this.deleteModifierRow();
                    _this.sendAttributeForm();
                    _this.inputValidation();
                    _this.previewChange();
                    _this.renderPreview();
                    // Run it once on open. Without this an already-valid set opened with Save
                    // greyed out until you touched a field for no reason.
                    if (_this.formValidation('attributes-form', true) && $('#attributes-rows .attributes-edit-row').length) {
                        $('#attributes-submit-form').removeAttr('disabled');
                    }
                }
            };
            if (attributeId){
                ajaxData.data = {
                    id: attributeId
                }
            }
            $.ajax(ajaxData);
        });
    },

    inputValidation(){
        const validate = ()=>{
            let result = this.formValidation('attributes-form', true);
            if(result && $('#attributes-rows .attributes-edit-row').length)
                $('#attributes-submit-form').removeAttr('disabled');
            else
                $('#attributes-submit-form').attr('disabled', true);
        }
        $('body').off('input', '#attributes-form .attributes-edit-value')
                .on('input', '#attributes-form .attributes-edit-value', validate);
        $('body').off('input', '#attributes-form .attributes-edit-title')
                .on('input', '#attributes-form .attributes-edit-title', validate);
        $('body').off('input', '#attributes-title')
                .on('input', '#attributes-title', validate);
    },

    isPlan(){
        let type = $('#attributes-type').val();
        return type === 'subscription' || type === 'boost';
    },

    /**
     * The two cards replace the old Standard / Subscription / Boost dropdown.
     */
    kindChange(){
        let _this = this;
        $('body').off('change', 'input[name="attributes-kind"]')
            .on('change', 'input[name="attributes-kind"]', function(){
                let kind = $(this).data('kind');
                if ($('#attributes-type').val() === kind) return;

                $('#attributes-type').val(kind);

                _this.returnSubscriptionVariants();

                let plan = _this.isPlan();
                // A plan is always one-answer and always a percentage off, so its two
                // controls are meaningless and hidden rather than left lying around.
                $('.bb-attr-detail-only').toggleClass('d-none', plan);
                if (plan) {
                    $('#attributes-multiple').val('on');
                    $('#attributes-picks').val('one');
                }
                $('#attributes-kind-hint').text(plan
                    ? 'Each plan discounts the order total.'
                    : 'Each modifier changes the price and the time.');

                _this.convertModifierRows();
            });
    },

    picksChange(){
        let _this = this;
        $('body').off('change', '#attributes-picks')
            .on('change', '#attributes-picks', function(){
                // Stored inverted: 'on' means the customer picks exactly one.
                $('#attributes-multiple').val(this.value === 'one' ? 'on' : '');
                _this.renderPreview();
            });
    },

    unitChange(){
        let _this = this;
        $('body').off('change', '#attributes-unit')
            .on('change', '#attributes-unit', function(){
                let unit = this.value;
                if ($('#attributes-amount').val() === unit) return;
                $('#attributes-amount').val(unit);
                $('#attributes-form [data-hint]').prop('hidden', true);
                $('#attributes-form [data-hint="' + unit + '"]').prop('hidden', false);
                _this.convertModifierRows();
            });
    },

    /**
     * "Adds" / "Reduces" in words, on the documented select. The select IS the posted field now,
     * so nothing has to be mirrored into a hidden input — only the live preview needs redrawing.
     */
    directionChange(){
        let _this = this;
        $('body').off('change', '.attributes-edit-direction')
            .on('change', '.attributes-edit-direction', function(){
                _this.renderPreview();
            });
    },

    /**
     * Was resetModifierRows(), which did `$('#attributes-rows').html('')` — changing the kind
     * or the unit silently threw away every modifier row already typed in, with no warning and
     * no undo. Convert the rows in place instead so nothing is lost.
     */
    convertModifierRows(){
        let form = $('#attributes-form');
        let plan = this.isPlan();

        // A job detail can be priced either way; a plan is always a percentage off.
        if (plan) {
            $('#attributes-amount').val('percent');
        }
        let wantPercent = plan || $('#attributes-amount').val() === 'percent';
        let valueField = wantPercent ? 'percent' : 'price';

        let variants = {};
        try {
            variants = JSON.parse(form.attr('data-subscription-variants') || '{}');
        } catch (e) {
            variants = {};
        }

        let maxSort = -1;
        form.find('.attributes-edit-row').each(function(){
            let row = $(this);
            let index = row.attr('data-sort');
            let isFirst = row.hasClass('is-first');
            maxSort = Math.max(maxSort, parseInt(index, 10) || 0);

            // Value field: price <-> percent, keeping whatever the user typed. Matched by name
            // because .attributes-edit-value also covers the Extra time input.
            let valueInput = row.find('[name$="[price]"], [name$="[percent]"]').first();
            if (valueInput.length) {
                valueInput.attr('name', `modifiers[${index}][${valueField}]`);
            }

            if (!isFirst) {
                // Direction control: a plan only ever discounts, so it is pinned to "reduce" and
                // hidden; a job detail gets it back.
                let dirSelect = row.find('.attributes-edit-direction');
                if (plan) dirSelect.val('reduce');
                dirSelect.prop('hidden', plan);
                row.find('.bb-mod-row__lead').toggle(plan);
                if (!row.find('.bb-mod-row__lead').length && plan) {
                    dirSelect.after('<span class="bb-mod-row__base bb-mod-row__lead">discount</span>');
                }
                // Affixes: $ before a flat amount, % (or "% off") after a percentage.
                let amountWrap = row.find('.bb-mod-row__cell--amount');
                amountWrap.find('.bb-affix').remove();
                if (plan) {
                    amountWrap.append('<span class="bb-affix" aria-hidden="true">% off</span>');
                } else if (wantPercent) {
                    amountWrap.append('<span class="bb-affix" aria-hidden="true">%</span>');
                } else {
                    amountWrap.prepend('<span class="bb-affix" aria-hidden="true">$</span>');
                }
            } else {
                row.find('.bb-mod-row__base').first().text(plan ? 'full price' : 'starting price');
            }

            // Title control: free text <-> subscription variant picker.
            let titleInput = row.find('.attributes-edit-title').first();
            if (!titleInput.length) return;

            if (plan && !titleInput.is('select')) {
                let options = Object.keys(variants).map(function(k){
                    return $('<option></option>').attr('value', k).text(variants[k]);
                });
                let select = $('<select class="bb-select attributes-edit-title"></select>')
                    .attr('name', `modifiers[${index}][title]`)
                    .append(options);
                titleInput.replaceWith(select);
            } else if (!plan && titleInput.is('select')) {
                // Carry the human label across, the same value the server renders for a saved
                // subscription row once the set is no longer a plan.
                let text = $('option:selected', titleInput).text() || '';
                let input = $('<input class="bb-input attributes-edit-title" type="text">')
                    .attr('name', `modifiers[${index}][title]`)
                    .val(text);
                titleInput.replaceWith(input);
            }
        });

        // returnSubscriptionVariants() used to zero this because every row was about to be
        // destroyed. The rows survive now, so a zeroed counter would make the next added row
        // collide with an existing one.
        $('input[name="increment"]').val(maxSort + 1);

        // Masking is delegated off `inputmode` in services.js initInputMasks(), so rows keep
        // their mask through a kind/unit change with nothing to re-apply.
        if (this.formValidation('attributes-form', true) && $('#attributes-rows .attributes-edit-row').length) {
            $('#attributes-submit-form').removeAttr('disabled');
        } else {
            $('#attributes-submit-form').attr('disabled', true);
        }
        this.renderPreview();
    },

    deleteModifierRow() {
        let _this = this;
        // The first row is the baseline and can never be removed; beyond that a set needs at
        // least two rows to be a choice at all.
        const modifiersCount = () => {
            let deletable = $('#attributes-rows .attributes-edit-row').not('.is-first')
                                .find('.attributes-modal__delete-modifier');
            deletable.toggleClass('is-disabled disabled', $('#attributes-rows .attributes-edit-row').length <= 2);
        }

        $('body').off('click', '.attributes-modal__delete-modifier')
            .on('click', '.attributes-modal__delete-modifier', function(){
                if ($(this).hasClass('disabled') || $(this).closest('.attributes-edit-row').hasClass('is-first')) return;
                let incrementInput = $('input[name="increment"]');
                let variantsInput = $('input[name="subscription_variants"]');
                incrementInput.val(Math.max(0, parseInt(incrementInput.val()) - 1));
                let modifierId = $(this).data('id');
                let chosenVariantElement = $('#modifier-id-' + modifierId + ' .attributes-edit-title');
                let chosenVariant = chosenVariantElement.val();
                let variants = JSON.parse(variantsInput.val());
                if (chosenVariantElement.is('select') && $('option:selected', chosenVariantElement).text() !== '') {
                    variants[chosenVariant] = $('option:selected', chosenVariantElement).text();
                }
                variantsInput.val(JSON.stringify(variants));
                $('#modifier-id-' + modifierId, $('#attributes-rows')).remove();
                modifiersCount();
                _this.renderPreview();
            });

        modifiersCount();
    },

    returnSubscriptionVariants(){
        let variantsInput = $('input[name="subscription_variants"]');
        let variantsElements = $('select.bb-select.attributes-edit-title').toArray();
        if (variantsElements.length > 0) {
            let variants = JSON.parse(variantsInput.val());
            variantsElements.forEach(element => {
                if (element.value != '') {
                    let chosenVariant = $(element).val();
                    variants[chosenVariant] = $('option:selected', $(element)).text();
                }
            });
            variantsInput.val(JSON.stringify(variants));
        }
        // The `increment` reset that used to live here moved into convertModifierRows():
        // it was only safe while the rows were about to be wiped.
    },

    showSelectHint(jqElem){
        let hintName = $('option:selected', jqElem).val();
        let hints = jqElem.parent().find('.attributes-modal__input-description');
        hints.addClass('d-none');
        $('div[data-hint="' + hintName + '"]').removeClass('d-none');
    },

    addModifier(){
        let _this = this;
        let attributesForm = document.getElementById('attributes-form');
        let attributesRowsWrapper = $('#attributes-rows');

        $('body').off('click', '.form-row__add-modifier-button')
            .on('click', '.form-row__add-modifier-button', function(){
            let formData = new FormData(attributesForm);
            let variantsInput = $('input[name="subscription_variants"]');
            let increment = formData.get('increment');
            let rowRequest = {
                increment,
                amount: formData.get('amount'),
                type: formData.get('type'),
                subscription_variants: formData.get('subscription_variants'),
            }
            $.ajax({
                type: 'GET',
                url: '/services-management/attributes/get-form-row',
                data: rowRequest,
                success: function (response) {
                    $('input[name="increment"]').val(++increment);
                    attributesRowsWrapper.append(response);
                    let chosenVariantElement = $('#modifier-id-' + increment + ' .attributes-edit-title');
                    let chosenVariant = chosenVariantElement.val();
                    let variants = JSON.parse(formData.get('subscription_variants'));
                    delete variants[chosenVariant];
                    variantsInput.val(JSON.stringify(variants));
                    _this.deleteModifierRow();
                    _this.sortModifier();
                    _this.renderPreview();
                },
                error: function (response) {
                    console.log(response);
                }
            });
        });
    },

    sortModifier(){
        $('.attributes-edit-row .btn-sort-attr').off('click').on('click',ev=>{
            let btn = $(ev.currentTarget)
            const direction = btn.attr('data-direction')
            let rows = $('#attributes-form .attributes-edit-row')
            let maxId = rows.length - 1
            let currRow = $(btn.parents('.attributes-edit-row')[0])
            let id = Number(currRow.attr('data-sort'))
            let directId = -1
            let destRow = null
            let method = null
            if(direction == 'up' && id != 0){
                directId = id-1
                destRow = $(rows[directId])
                method = 'insertBefore'
            }else if(direction == 'down' && id!=maxId){
                directId = id+1
                destRow = $(rows[directId])
                method = 'insertAfter'
            }
            if(directId != -1 && destRow != null){
                ['key','title','extra_time','price','percent','direction'].forEach(f => {
                    destRow.find(`[name="modifiers[${directId}][${f}]"]`)?.attr('name', `modifiers[${id}][${f}]`)
                })
                destRow.attr('data-sort', id)
                destRow.attr('id', `modifier-id-${id}`)
                ;['key','title','extra_time','price','percent','direction'].forEach(f => {
                    currRow.find(`[name="modifiers[${id}][${f}]"]`)?.attr('name', `modifiers[${directId}][${f}]`)
                })
                currRow.attr('data-sort', directId)
                currRow.attr('id', `modifier-id-${directId}`)
                currRow[method](destRow)
            }
        })
    },

    previewChange(){
        let _this = this;
        $('body').off('input', '#attributes-preview-price, #attributes-preview-duration')
            .on('input', '#attributes-preview-price, #attributes-preview-duration', () => _this.renderPreview());
        $('body').off('input.preview', '#attributes-rows .attributes-edit-value, #attributes-rows .attributes-edit-title')
            .on('input.preview', '#attributes-rows .attributes-edit-value, #attributes-rows .attributes-edit-title', () => _this.renderPreview());
        $('body').off('change.preview', '#attributes-rows select.attributes-edit-title')
            .on('change.preview', '#attributes-rows select.attributes-edit-title', () => _this.renderPreview());
    },

    /**
     * The point of the rebuild: the real customer-facing price, before saving. Money is done in
     * integer cents so the preview matches what the server will charge.
     */
    renderPreview(){
        let body = $('#attributes-preview-body');
        if (!body.length) return;

        const baseCents = Math.round((parseFloat($('#attributes-preview-price').val()) || 0) * 100);
        const baseMins  = parseInt($('#attributes-preview-duration').val(), 10) || 0;
        const plan      = this.isPlan();
        const percent   = plan || $('#attributes-amount').val() === 'percent';

        const money = c => '$' + (c / 100).toFixed(2);
        const hm = m => {
            let h = Math.floor(m / 60), x = m % 60;
            return (h ? h + ' hr' + (h > 1 ? 's' : '') : '') + (h && x ? ' ' : '') + (x ? x + ' min' : '') || '0 min';
        };

        let lines = [];
        $('#attributes-rows .attributes-edit-row').each(function(){
            let row = $(this);
            let titleEl = row.find('.attributes-edit-title').first();
            let title = titleEl.is('select') ? $('option:selected', titleEl).text() : (titleEl.val() || '');
            if (!title) title = '(untitled)';

            let isFirst = row.hasClass('is-first');
            let amount = parseFloat(row.find('[name$="[price]"], [name$="[percent]"]').first().val()) || 0;
            let mins = parseInt(row.find('[name$="[extra_time]"]').val(), 10) || 0;
            let dir = row.find('.attributes-edit-direction').val() || 'add';
            let sign = (plan || dir === 'reduce') ? -1 : 1;

            let deltaCents = isFirst ? 0
                : (percent ? Math.round(baseCents * Math.round(amount * 100) / 10000) * sign
                           : Math.round(amount * 100) * sign);

            let effect;
            if (isFirst) {
                effect = plan ? 'full price' : 'starting price';
            } else if (plan) {
                effect = amount + '% off';
            } else if (percent) {
                effect = (sign < 0 ? 'saves ' : 'adds ') + amount + '%';
            } else {
                effect = (sign < 0 ? 'saves ' : 'adds ') + money(Math.abs(deltaCents));
            }

            lines.push(
                '<div class="bb-attr-preview__row">' +
                    '<span class="bb-attr-preview__name">' + $('<div>').text(title).html() + '</span>' +
                    '<span class="bb-attr-preview__effect">' + effect + '</span>' +
                    '<span class="bb-attr-preview__total">' + money(baseCents + deltaCents) +
                        (mins ? ' · ' + hm(baseMins + mins) : ' · ' + hm(baseMins)) + '</span>' +
                '</div>'
            );
        });

        body.html(lines.join('') || '<div class="bb-attr-preview__row"><span class="bb-attr-preview__name">No modifiers yet.</span></div>');
    },

    sendAttributeForm(){
        let $this = this;
        $('#attributes-submit-form').click(function(){
            this.SaveBtn = new SaveButton();
            let result = $this.formValidation('attributes-form');
            if (result) {
                $.ajax({
                    type: 'POST',
                    url: '/services-management/attributes/save-attribute',
                    data: $('#attributes-form').serialize(),
                    beforeSend: () =>{
                        this.SaveBtn.startLoading();
                    },
                    success: () => {
                        this.SaveBtn.stopLoading().then(
                            () => {
                                this.SaveBtn.showSuccess().then(
                                    function() {
                                        $('#attributes-modal').modal('hide');
                                        location.reload(true);
                                    }
                                )
                            }
                        );
                    },
                    error: (response) => {
                        this.SaveBtn.showError().then(
                            () => {
                                this.SaveBtn.stopLoading();
                            }
                        );

                    }
                });
            }
        });
    },
    getFormItems() {
        let _this = this;
        $('.attributes-list__table-apply-service-link').click(function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/modifier_get_form_items',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function (response) {
                    $('#form-container').html(response);
                    $('#modifier-modal').modal('show');
                    _this.applyToServicesCount();
                }
            })
        });

        this.saveFormItems();
    },

    /** "N of M selected", so you can see what you are about to save without counting ticks. */
    applyToServicesCount(){
        const update = () => {
            const boxes = $('#modifier-form input[type=checkbox]');
            const on = boxes.filter(':checked').length;
            $('#modifier-items-count').text(
                boxes.length ? on + ' of ' + boxes.length + ' selected' : ''
            );
        };
        $('body').off('change.applycount', '#modifier-form input[type=checkbox]')
            .on('change.applycount', '#modifier-form input[type=checkbox]', update);
        update();
    },

    /**
     * Apply set to services never saved. The button carried no handler at all and sat OUTSIDE
     * <form id="modifier-form">, so clicking it did nothing — no request, no error, the modal just
     * stayed open. The endpoint was fine the whole time; only this was missing.
     */
    saveFormItems(){
        $('body').off('click', '#modifier-submit-form')
            .on('click', '#modifier-submit-form', function (e) {
                e.preventDefault();
                const SaveBtn = new SaveButton('#modifier-modal');
                $.ajax({
                    type: 'POST',
                    url: '/modifier_save_items',
                    data: new FormData(document.getElementById('modifier-form')),
                    processData: false,
                    contentType: false,
                    beforeSend: () => SaveBtn.startLoading(),
                    success: () => {
                        SaveBtn.stopLoading().then(() => SaveBtn.showSuccess()).then(() => {
                            // The Used by column and every service's question list just changed.
                            location.reload(true);
                        });
                    },
                    error: () => SaveBtn.stopLoading().then(() => SaveBtn.showError()),
                });
            });
    },

    formValidation(formId, withoutColor=false){
        if ($(`#${formId}`).length>0) {
            let flag = true;
            const values = $(`#${formId}`).find('.attributes-edit-value').toArray();
            values.forEach(element => {
                if ($(element).val() == '') {
                    if(!withoutColor)
                        $(element).css('border-color', 'red');
                    flag = false;
                }else if(!withoutColor){
                    $(element).css('border-color', '');
                }
            });
            const titles = $(`#${formId}`).find('.attributes-edit-title').toArray();
            titles.forEach(element => {
                if ($(element).val() == '') {
                    if(!withoutColor)
                        $(element).css('border-color', 'red');
                    flag = false;
                }else if(!withoutColor){
                    $(element).css('border-color', '');
                }
            });
            if ($('#attributes-title').val()=='') {
                if(!withoutColor)
                    $('#attributes-title').css('border-color', 'red');
                flag = false;
            }else if(!withoutColor){
                $('#attributes-title').css('border-color', '');
            }
            return flag;
        }else{
            return false;
        }
    },

    modifierMenu(){
        $('body').off('click', '.modifier-menu-btn')
        .on('click', '.modifier-menu-btn', function(e) {
            const parentRow = $(this).parents('.form-group');

            if ($(parentRow).find('.modifier-menu-modal').hasClass('opened')) {
                $(parentRow).find('.modifier-menu-modal').removeClass('opened');
            } else {
                $('.modifier-menu-modal').removeClass('opened');
                $(parentRow).find('.modifier-menu-modal').addClass('opened');
            }
            let posX = $(this).position().left - ($('.modifier-menu-modal').width() + 10);
            let posY = $(this).position().top + 10;
            $('.modifier-menu-modal').css({left: posX, top: posY});
        });
        $('body').off('click', '.modifier-menu-modal .close-elem')
        .on('click', '.modifier-menu-modal .close-elem', function() {
            $(this).parents('.modifier-menu-modal').removeClass('opened');
        });
    }
}
